const mobileMenu = {
	namespaced: true,
	state: {
		left: {
			toggle: false
		},
		right: {
			toggle: false
		},		
	},
	getters: {
		leftMobileMenu(state){
			return state.left.toggle
		},
		rightMobileMenu(state){
			return state.right.toggle
		}
	},
	mutations: {
		setLeftMenu(state, leftData){
			state.left.toggle = leftData
		},
		setRightMenu(state, rightData){
			state.right.toggle = rightData
		}
	},
	actions: {
		toggleLeftMenu({ commit }, toggle){
			if(toggle) document.body.classList.add('overflowYHidden');
			if(!toggle) document.body.classList.remove('overflowYHidden');
			commit('setLeftMenu', toggle)
		},
		toggleRightMenu({ commit }, toggle){
			if(toggle) document.body.classList.add('overflowYHidden');
			if(!toggle) document.body.classList.remove('overflowYHidden');
			commit('setRightMenu', toggle)
		}
	}
}

export default mobileMenu;


// WEBPACK FOOTER //
// ./src/store/mobileMenu.js